import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { CommonService } from '../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { IncometaxService } from '../Model/Incometax/incometax.service';
import { ComboService } from '../Model/Combo/combo.service';
import { DownloadSampleService } from '../Model/DownloadSample/download-sample.service';

@Component({
  selector: 'app-investment-declaration-details',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, NgSelectModule, NgbDropdownModule, LoaderComponent],
  templateUrl: './investment-declaration-details.component.html',
  styleUrl: './investment-declaration-details.component.scss'
})
export class InvestmentDeclarationDetailsComponent {

  isDisabled: boolean = false;
  TableDatas: any[] = [];
  Branchs = null as any;
  FinancialYears: any[] = [];

  constructor(
    protected common: CommonService,
    private toast: ToastService,
    private incometax: IncometaxService,
    private combo: ComboService,
    private download: DownloadSampleService
  ) { }

  ngOnInit() {
    this.ComboLoad('Branch');
    this.ESS_TaxFinancialYearSelect();
  }

  Detail = {
    SelectType: 'Monthly Provisional Report',
    TaxBasedon: '',
    TaxMonth: '',
    EmpmasterID: 0,
    EmpType: '',
    FinancialYear: null as any,
    BranchID: null as any,
    Quarter: null as any,
    SiteIDs: '',
    Empcode: '',
    UserID: 0
  };

  ESS_TaxFinancialYearSelect(): void {
    this.isDisabled = true;

    const requestData = {
      SelectType: 'S',
      ESS_TaxFinancialYearID: null,
      FinancialYearFrom: null,
      FinancialYearTo: null
    };

    this.incometax.ESS_TaxFinancialYearSelect(requestData).subscribe({
      next: (response: any) => {

        if (response && response.Table && Array.isArray(response.Table)) {
          this.FinancialYears = response.Table.map((element: any) => {
            const startYear = new Date(element.FinancialYearStart).getFullYear();
            const endYear = new Date(element.FinancialYearEnd).getFullYear();

            return {
              ...element, FinancialYear: `${startYear} - ${endYear}`,
              FinancialYearValue: `${startYear}${endYear.toString().substring(2)}`
            };
          }
          );

          // Find active financial year
          const activeYear = this.FinancialYears.find((x: any) => x.IsActive === true || x.IsActive === 1 || x.IsActive === '1');

          if (activeYear) {
            this.Detail.FinancialYear = activeYear.FinancialYearValue;
          }
        } else {
          this.FinancialYears = [];
        }
        this.isDisabled = false;
      },

      error: (error: any) => {
        this.FinancialYears = [];
        this.isDisabled = false;
        this.toast.show({ message: 'Unable to load Financial Year', type: toastTypeEnum.warning });
      }
    });
  }

  ComboLoad(Combotype: string, isChecked = false): void {
    this.isDisabled = true;
    const requestData = {
      Combotype: Combotype,
      BranchId: this.Detail.BranchID
    };
    this.combo.ComboLoad(requestData).subscribe({
      next: (response: any) => {

        if (response && response.ComboLoad && Array.isArray(response.ComboLoad)) {
          if (Combotype === 'Branch') {
            this.Branchs = response.ComboLoad;
          }
        } else {
          if (Combotype === 'Branch') {
            this.Branchs = [];
          }
        }
        this.isDisabled = false;
      },

      error: (error: any) => {
        this.isDisabled = false;
        this.toast.show({ message: 'Unable to load Branch', type: toastTypeEnum.warning });
      }
    });
  }

  excelDownload(): void {
    if (!this.Detail.FinancialYear) {
      this.toast.show({
        message: 'Please Select Financial Year',
        type: toastTypeEnum.warning
      });

      return;
    }

    this.isDisabled = true;

    const requestData = {
      SelectType: 'Investment Declaration Details',
      TaxBasedon: this.Detail.TaxBasedon,
      TaxMonth: '',
      EmpmasterID: 0,
      EmpType: this.Detail.EmpType,
      FinancialYear: this.Detail.FinancialYear,
      BranchID: this.Detail.BranchID,
      Quarter: '',
      SiteIDs: '',
      Empcode: this.Detail.Empcode,
    }

    this.incometax.GetIncomeTaxReport(requestData).subscribe({
      next: (response: any) => {

        if (response?.Table && Array.isArray(response.Table) && response.Table.length > 0) {
          this.TableDatas = response.Table;
          this.download.exportToExcelWithProgress(this.TableDatas, 'Investment Declaration Details')
          this.toast.show({message: 'Excel generated successfully',type: toastTypeEnum.success});
        } else {
          this.TableDatas = [];
          this.toast.show({message: 'No Data Found',type: toastTypeEnum.warning});
        }
        this.isDisabled = false;
      },

      error: (error: any) => {
        console.error('GetIncomeTaxReport Excel API Error =>',error);
        this.isDisabled = false;
        this.toast.show({message: 'Unable to generate Excel',type: toastTypeEnum.warning});
      }
    });
  }

}
